import { render, staticRenderFns } from "./admin-selector.vue?vue&type=template&id=2ccc1366"
import script from "./admin-selector.vue?vue&type=script&lang=js"
export * from "./admin-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports